import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { Invoice } from 'src/app/models/invoice.model';
import { InvoiceService } from 'src/app/services/invoice_service.service';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-invoice-dialog',
    templateUrl: './invoice-dialog.component.html',
    styleUrls: ['./invoice-dialog.component.scss'],
    imports: [MatDialogTitle, MatProgressBar, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatCheckbox, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatDialogActions, MatButton, MatDialogClose]
})
export class InvoiceDialogComponent implements OnInit {
    updatingInvoice: boolean = false;
    invoices: any[] = [];
    dataSource = new MatTableDataSource();
    serviceProviderName: string = '';
    serviceProviderBusinessName: string = '';
    displayedColumns: string[] = [
        'Service Plan',
        'Customer',
        'Service Type',
        'Bill',
        'Paid'
    ];

    constructor(
        public dialogRef: MatDialogRef<InvoiceDialogComponent>,
        public invoiceService: InvoiceService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit() {
        this.invoices = this.data;
        this.serviceProviderName = this.invoices[0].serviceProvider.name;
        this.serviceProviderBusinessName = this.invoices[0].serviceProvider.businessName;
        this.dataSource.data = this.invoices;
    }

    updateInvoicePaidStatus(invoice: Invoice): void {
        this.updatingInvoice = true;
        invoice.paid = !invoice.paid
        this.invoiceService.put([invoice.invoiceId], invoice).subscribe(() => {
            this.updatingInvoice = false;
        },() => {
            this.updatingInvoice = false;
        });
    }

}
